import { render, staticRenderFns } from "./RenameDialog.vue?vue&type=template&id=ebc9ea74"
import script from "./RenameDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports